/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "twitter-white-8f1211d0--sprite",
  "use": "twitter-white-8f1211d0--sprite-usage",
  "viewBox": "0 0 26 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 21\" id=\"twitter-white-8f1211d0--sprite\"><path d=\"M25.5 2.403c-.92.407-1.907.684-2.945.807A5.15 5.15 0 0024.81.375a10.34 10.34 0 01-3.26 1.245 5.129 5.129 0 00-8.739 4.676A14.56 14.56 0 012.242.937a5.09 5.09 0 00-.693 2.578c0 1.78.906 3.35 2.281 4.268a5.129 5.129 0 01-2.323-.644v.064a5.134 5.134 0 004.113 5.03c-.43.115-.882.179-1.351.179-.331 0-.651-.033-.965-.096a5.131 5.131 0 004.79 3.562 10.29 10.29 0 01-6.37 2.192A10.9 10.9 0 01.5 18a14.497 14.497 0 007.861 2.307c9.434 0 14.591-7.814 14.591-14.59l-.017-.665a10.24 10.24 0 002.565-2.65z\" fill=\"#fff\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
